const dict: Record<string, string> = {
  // Nav
  dashboard: "Dashboard",
  catalog: "Catalog",
  cart: "Cart",
  orders: "Orders",
  account: "Account",
  invoices: "Invoices",
  nav_main: "Workspace",
  nav_account: "Account",

  // Common
  search: "Search",
  search_products: "Search by SKU, name...",
  filter: "Filter",
  sort: "Sort",
  add_to_cart: "Add",
  in_cart: "In cart",
  place_order: "Place order",
  add_short: "Add",
  add_more: "Add more",
  total: "Total",
  subtotal: "Subtotal",
  discount: "Discount",
  delivery: "Delivery",
  qty: "Qty",
  qty_decrement: "Decrease quantity",
  qty_increment: "Increase quantity",
  logist_addr_derybasivska: "Derybasivska 12",
  logist_addr_tairova: "Tairova · Glushka 32",
  logist_addr_sklad: "Warehouse · Promyslova 4",
  unit: "Per unit",
  price: "Price",
  retail: "Retail",
  your_price: "Your price",
  saved: "You save",
  sku: "SKU",
  stock: "Stock",
  in_stock: "In stock",
  low_stock: "Low",
  out_of_stock: "Out",
  create_order: "Create order",
  repeat_order: "Repeat last order",
  view_all: "View all",
  items: "Items",
  items_word: "items",
  amount: "Amount",
  product: "Product",
  status: "Status",
  payment: "Payment",
  paid: "Paid",
  unpaid: "Unpaid",
  free: "Free",
  optional: "optional",
  clear: "Clear",
  retry: "Retry",
  repeat: "Repeat",
  invoice: "Invoice",
  order: "Order",
  date: "Date",
  due: "Due",
  due_by: "by",
  primary: "Primary",
  primary_m: "Primary",
  yes: "Yes",
  no: "No",
  all: "All",
  view: "View",
  admin: "Admin",
  user: "User",
  invite: "Invite",
  added: "Added:",
  category: "Category",

  // Status
  status_new: "New",
  status_processing: "Processing",
  status_shipped: "Shipped",
  status_delivered: "Delivered",
  status_cancelled: "Cancelled",

  // Login
  login_title: "Sign in to B2B portal",
  login_sub: "Access wholesale ordering for your business.",
  email: "Email",
  password: "Password",
  show_password: "Show password",
  hide_password: "Hide password",
  forgot: "Forgot password?",
  sign_in: "Sign in",
  or: "or",
  magic: "Send me a login link",
  magic_link_send: "Send magic link",
  magic_check_email: "Check your email",
  no_account: "No access yet?",
  request: "Request an account",
  wholesale_portal: "Wholesale portal",
  signing_in: "Signing in...",
  invalid_email: "Invalid email",
  check_inbox: "Check your inbox",
  magic_sent: "We sent a sign-in link to",
  magic_expire: "It expires in 15 minutes.",
  back_to_password: "Back to password",
  brand_panel_copy:
    "Order beans, gear, and accessories direct from the roastery with negotiated pricing, Net-14 terms, and a dedicated account manager.",
  partner_venues: "partner venues",
  on_market: "on market",
  payment_terms_label: "payment terms",

  // Dashboard
  welcome: "Welcome back",
  your_tier: "Your tier",
  personal_manager: "Personal manager",
  balance: "Balance",
  recent_orders: "Recent orders",
  quick_actions: "Quick actions",
  today_date_long: "APRIL 18, 2026 · SATURDAY",
  dash_sub_a: "Your balance, orders, and quick actions for ",
  dash_sub_b: ".",
  credit: "Credit",
  tier_b_hint: "Custom pricing — 20% off retail",
  saved_this_year: "Saved this year",
  across_word: "across",
  orders_word: "orders",
  active_orders: "Active orders",
  one_processing: "1 processing",
  send_message: "Send a message",
  whats_new: "What's new",
  frequent_items: "Your frequent items",
  one_click_reorder: "One-click reorder",

  // Catalog
  categories: "Categories",
  availability: "Availability",
  origin: "Origin",
  weight: "Weight",
  cat_beans: "Whole bean",
  cat_ground: "Ground / drip",
  cat_equipment: "Equipment",
  cat_accessories: "Accessories",
  cat_training: "Training",
  view_grid: "Grid",
  view_table: "Table",
  wholesale_catalog: "Wholesale catalog",
  catalog_sub_a: " SKUs · Prices reflect your HoReCa Tier B agreement",
  any_availability: "Any availability",
  featured: "Featured",
  price_low_high: "Price: low → high",
  price_high_low: "Price: high → low",
  alpha: "A → Z",
  all_items: "All items",
  catalog_err: "Couldn't load catalog",
  catalog_err_sub: "Check your connection and retry.",
  nothing_found: "Nothing found",
  nothing_found_sub: "Try different keywords or clear your filters.",
  clear_filters: "Clear filters",
  restocking: "Restocking",

  // Cart
  your_cart: "Your cart",
  empty_cart: "Cart is empty",
  empty_cart_sub: "Add products from the catalog to start an order.",
  go_to_catalog: "Browse catalog",
  order_summary: "Order summary",
  delivery_address: "Delivery address",
  payment_method: "Payment method",
  payment_terms: "Net-14 terms",
  delivery_method: "Delivery method",
  choose_one: "Choose one",
  odesa_logist: "Foundation logist · Odesa",
  odesa_logist_meta: "1–2 business days · within city",
  odesa_logist_short: "Odesa logist",
  np_short: "Nova Poshta",
  min_prefix: "min.",
  available_from: "Available from",
  shortfall_a: "Add ",
  shortfall_b: " more to qualify, or pick Nova Poshta below.",
  add_items: "Add items",
  switch_to_np: "Switch to Nova Poshta",
  np_branch: "Nova Poshta · pickup branch",
  np_meta: "1–3 business days · nationwide",
  city: "City",
  branch_num: "Branch №",
  order_note: "Order note",
  order_note_ph: "Delivery notes, labelling requests, etc...",
  delivery_via_odesa: "Delivery · Odesa logist",
  delivery_via_np: "Delivery · Nova Poshta",
  incl_vat: "Incl. VAT 20% ·",
  payment_status_unpaid: "Payment status: Unpaid",
  payment_status_unpaid_sub:
    "Order is created without immediate payment. Your manager will send an invoice.",
  net14_note: "No immediate payment · NET-14",
  order_copied: "Order copied to cart",
  order_created_a: "Order created ·",
  order_created_b: "· Unpaid",
  order_error: "Couldn't place the order. Please try again.",

  // Orders
  order_history: "Order history",
  order_num: "Order №",
  ordered_on: "Placed",
  orders_total_suffix: " total orders · Click to see details",
  search_by_num: "Search by number...",
  no_orders: "No orders yet",
  fulfilment: "Fulfilment",
  line_items: "Line items",
  unpaid_awaiting: "Unpaid · awaiting invoice",
  payment_colon: "Payment:",
  download_invoice: "Download invoice",
  invoice_sent: "Invoice sent to your email",

  // Account
  company: "Company",
  addresses: "Addresses",
  payment_methods: "Payment",
  account_settings: "Account & settings",
  account_sub: "Manage your company, delivery addresses, and payment methods.",
  team: "Team",
  preferences: "Preferences",
  company_details: "Company details",
  save_changes: "Save changes",
  legal_name: "Legal name",
  brand_name: "Brand name",
  tax_id: "Tax ID",
  vat_registered: "VAT registered",
  billing_email: "Billing email",
  phone: "Phone",
  your_manager: "Your manager",
  payment_terms_row: "Payment terms",
  customer_since: "Customer since",
  upgrade_tier: "Upgrade to Tier A at 500 000 UAH/yr — 84 000 UAH to go.",
  credit_line: "Credit line",
  available_word: "available",
  used: "Used",
  limit: "Limit",
  delivery_addresses: "Delivery addresses",
  add_address: "Add address",
  payment_methods_title: "Payment methods",
  add_method: "Add method",
  net14_apply: "Net-14 terms apply automatically to orders over 5 000 UAH.",
  owner_role: "Owner",
  procurement: "Procurement",
  head_barista: "Head barista",
  team_members: "Team members",
  team_role: "Role",
  role_orders: "Orders",
  notifications: "Notifications",
  notif_status: "Order status updates",
  notif_restock: "Restock alerts",
  notif_new_arrivals: "New catalog arrivals",
  notif_promo: "Seasonal promotions",

  // Invoices
  invoices_title: "Invoices & documents",
  invoices_sub: "Tax invoices, delivery acts, and receipts.",
  export_csv: "Export CSV",

  // Shell
  menu: "Menu",
  help: "Help",
  search_placeholder: "Search everything...",
  close: "Close",
  guest: "Guest",
  logout: "Log out",
  remove: "Remove",

  // Not found
  not_found_title: "Page not found",
  not_found_subtitle: "The link may be outdated or the page may have moved.",
  go_to_dashboard: "Go to dashboard",

  // Misc
  today: "today",
  yesterday: "yesterday",
  days_ago: "d ago",

  // Register
  r_eyebrow: "Wholesale portal · Apply",
  r_title: "Request an account",
  r_sub:
    "Tell us about your business — your manager will prepare a custom quote within 1 business day.",
  r_s1: "Company",
  r_s2: "Business",
  r_s3: "Contact",
  r_step: "Step",
  r_of: "of",
  r_required_field: "Please fill in the required fields",
  r_company_legal: "Legal name",
  r_company_hint: "LLC / sole proprietor",
  r_edrpou: "Tax ID",
  r_vat: "VAT registered",
  r_yes: "Yes",
  r_no: "No",
  r_brand_name: "Business name (brand)",
  r_brand_hint: "Public-facing name customers see",
  r_venue_type: "Venue type",
  r_cafe: "Café",
  r_restaurant: "Restaurant",
  r_hotel: "Hotel",
  r_office: "Office / corporate",
  r_reseller: "Reseller",
  r_other: "Other",
  r_venues: "Number of locations",
  r_volume: "Estimated monthly coffee volume",
  r_v1: "Under 20 kg",
  r_v2: "20–50 kg",
  r_v3: "50–150 kg",
  r_v4: "150+ kg",
  r_name_full: "Contact full name",
  r_role: "Your role",
  r_owner: "Owner",
  r_buyer: "Procurement",
  r_barista: "Head barista",
  r_manager: "Manager",
  r_email: "Work email",
  r_phone: "Phone",
  r_note: "Note for manager",
  r_note_ph:
    "What you're currently sourcing, preferred brands, special needs...",
  r_accept_tos: "I agree to the terms of cooperation and data processing",
  r_accept_tos_required: "You need to accept the terms",
  r_continue: "Continue",
  r_back: "Back",
  r_submit: "Send application",
  r_submit_error: "Couldn't send the application. Please try again.",
  r_have_account: "Already have access?",
  r_sign_in: "Sign in",
  r_sent_title: "Application received!",
  r_sent_sub:
    "Anna Lytvyn, your future manager, will reach out within 24 hours at",
  r_what_next: "What happens next",
  r_n1: "Your manager will verify details and set custom HoReCa pricing",
  r_n2: "You'll receive an email with login and temporary password",
  r_n3: "First order ships with −5% off the entire cart",
  r_back_to_site: "Back to foundation.ua",
  r_why_title: "Why join Foundation B2B",
  r_w1_t: "Custom pricing",
  r_w1_s: "HoReCa tiers from −15% to −25% off retail",
  r_w2_t: "Net-14 terms",
  r_w2_s: "Deferred invoicing for established partners",
  r_w3_t: "Personal manager",
  r_w3_s: "Direct line, no ticket queue",
  r_w4_t: "Priority delivery",
  r_w4_s: "Next-day in Odesa, 2 days nationwide",
  r_for_venues: "For venues & resellers",
  r_hero_a: "Become a",
  r_hero_b: "Foundation",
  r_hero_c: "partner.",
  r_bottom_copy:
    "240+ venues across Ukraine source beans, gear, and accessories direct from our Odesa roastery.",
};

export default dict;
